{
  "eyebrow": "Потвърдете плана",
  "title": "Прегледайте и конфигурирайте.",
  "sub": "Можете да промените цикъла на фактуриране или плана по всяко време от админ панела.",
  "yourPlan": "Вашият план",
  "changePlan": "Промени плана",
  "billing": "Цикъл на фактуриране",
  "billingMonthLabel": "Плащане месечно",
  "billingMonthDesc": "Гъвкаво. Отказ по всяко време.",
  "billingYearLabel": "Плащане годишно",
  "billingYearDesc": "~17% отстъпка. Фактурира се веднъж годишно.",
  "addons": "Добавки",
  "addon": {
    "ssec": "Социална осигуровка (check-in/out@work)",
    "ssecDesc": "Само Белгия — автоматична декларация Dimona.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "GPS в реално време за служебни автомобили. +4 €/превозно средство/месец.",
    "vehicles": "Превозни средства",
    "projectAddon": "Добавка за управление на проекти",
    "projectAddonDesc": "Отключва функциите за управление на проекти на Time Pro (допълнителна работа, планиране, управление на подизпълнители)."
  },
  "employees": {
    "title": "Колко служители?",
    "active": "активни потребители",
    "popular": "Повечето екипи избират {{n}}"
  },
  "estimate": "Прогнозна месечна цена",
  "estimateNote": "Без ДДС. Таксите на потребител се изчисляват според активните служители.",
  "estimateUnavailable": "Каталогът с цени е недостъпен. Опитайте отново, за да заредите най-новите цени."
}
